import React, { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Grid, Box, Paper, Typography, Divider, Button, LinearProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import ImageMUI from 'material-ui-image';
import { useSnackbar } from 'material-ui-snackbar-provider';
import { useTranslation } from 'react-i18next';
import { useGetImageByIdQuery, useDeleteImageMutation } from '../../apis/backend';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
  'actionButtons': {
    'margin': theme.spacing(3, 0),
    '& button:not(:last-child)': {
      marginRight: theme.spacing(1),
    }
  },
}));

const Image = () => {
  const [openDialog, setOpenDialog] = useState();

  const { imageName } = useParams();
  const history = useHistory();
  const classes = useStyles();
  const { t } = useTranslation();
  const snackbar = useSnackbar();

  const { imageType: container } = useParams();

  const skipGetImageById = !(imageName && container);
  const { data: image, isLoading, error } = useGetImageByIdQuery({ id: imageName, type: container }, { skip: skipGetImageById });

  if (error?.status == 404) history.push('/not-found');

  const [deleteImage] = useDeleteImageMutation();

  const handleDeleteImage = async () => {
    try {
      await deleteImage(imageName).unwrap();
      history.push({pathname: '/imagebank/print'});
      snackbar.showMessage(t('image-delete-success', { image }));
    } catch (err) {
      snackbar.showMessage(t('image-delete-fail', { image }), 'error');
    }
  };

  const handleCloseDialog = (confirmDelete) => {
    if(confirmDelete) handleDeleteImage();
    setOpenDialog(false);
  };

  const content = (
    <Box mt={4}>
      <Grid container spacing={4}>
        <Grid item sm={8}>
          <Paper elevation={0} variant="outlined">
            <ImageMUI
              style={{ padding: 0, minHeight: '100px' }}
              imageStyle={{ maxWidth: '100%', minHeight: 'auto', width: '100%', height: 'auto', position: 'unset' }}
              src={image?.url}
            />
          </Paper>
          <Box mt={3}>

          </Box>
          <Box className={classes.actionButtons} display="flex" justifyContent="flex-start">
            <Button variant="outlined" color="primary" onClick={() => history.goBack()}>{t('exit')}</Button>
            <Button variant="contained" color="primary" onClick={() => setOpenDialog(true)}>{t('delete')}</Button>
          </Box>
        </Grid>
        <Grid item sm={4}>
          <Paper elevation={1} variant="outlined">
            <Box m={2} ml={4}>
              <Typography variant="h6">Filename</Typography>
              <Typography variant="body1">{image?.file_name}</Typography>
            </Box>
            <Box m={2} ml={4}>
              <Typography variant="h6">Type</Typography>
              <Typography variant="body1">{image?.template_type}</Typography>
            </Box>
            <Box m={2} ml={4}>
              <Typography variant="h6">Size</Typography>
              <Typography variant="body1">{image?.file_size / 1000} KB</Typography>
            </Box>
            <Box m={2} ml={4}>
              <Typography variant="h6">Created</Typography>
              <Typography variant="body1">{image?.created}</Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>
      <Dialog
        open={openDialog}
        onClose={() => handleCloseDialog(false)}>
        <DialogTitle
          id="alert-dialog-title">
          {t('delete-image')}
        </DialogTitle>

        <DialogContent>
          <DialogContentText
            id="alert-dialog-description">
            {t('image-delete-alert')}
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => handleCloseDialog(false)}
            color="primary">
            {t('cancel')}
          </Button>

          <Button
            onClick={() => handleCloseDialog(true)}
            color="primary"
            autoFocus>
            {t('delete')}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );

  return (
    <>
      <Typography variant="h4">{image?.file_name}</Typography>
      <Divider />
      { isLoading && <Box width="100%"><LinearProgress /></Box>}
      { !isLoading && content}
    </>
  );
};


export default Image;
